import React, { useEffect } from "react";
import AuthService from "../../base/services/authentication.service";
import { UserRolesEnum } from "../../utils/enums";
import { Col, Form, Input, Row, Select } from "antd";
import { httpService } from "../../base/services/httpService.service";
import { useState } from "react";

const CompanyInformationSection = React.memo(({ countries }) => {
   const [organizationTypes, setOrganizationTypes] = useState([]);

   useEffect(() => {
      httpService.get(`/Account/getOrganizationTypes`, (res) => {
         try {
            setOrganizationTypes(res.data);
         } catch (error) {
            console.log(error);
         }
      });
   }, []);

   const isOrganizationUser = AuthService.isAuthorized([UserRolesEnum.Organization]);

   return (
      <>
         <div className="mt-8 mb-5">
            <h4>Company information</h4>
         </div>
         <Row gutter={24}>
            <Col xs={24} sm={12}>
               <Form.Item
                  name="organizationName"
                  label={<span className="label-text required">Organization's name</span>}
                  rules={[
                     {
                        required: isOrganizationUser,
                        message: "Please input organization name"
                     }
                  ]}
               >
                  <Input placeholder="Organization name" disabled={!isOrganizationUser} />
               </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
               <Form.Item
                  name="organizationTypeId"
                  label={<span className="label-text required">Type of organization</span>}
                  rules={[
                     {
                        required: isOrganizationUser,
                        message: "Please select an option"
                     }
                  ]}
               >
                  <Select
                     placeholder="Select an option"
                     options={organizationTypes?.map((item) => ({
                        value: item.id,
                        label: item.name
                     }))}
                     disabled={!isOrganizationUser}
                  />
               </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
               <Form.Item
                  name="organizationCountryId"
                  label={<span className="label-text required">Country</span>}
                  rules={[
                     {
                        required: isOrganizationUser,
                        message: "Please select an option"
                     }
                  ]}
               >
                  <Select
                     placeholder="Select an option"
                     showSearch
                     allowClear
                     filterOption={(input, option) => {
                        return (option?.label ?? "").toLowerCase().startsWith(input.toLowerCase());
                     }}
                     options={countries.map((item) => ({
                        value: item.id,
                        label: item.name
                     }))}
                     disabled={!isOrganizationUser}
                  />
               </Form.Item>
            </Col>
         </Row>
      </>
   );
});

export default CompanyInformationSection;
